// "8:10 AM" from an ISO timestamp; otherwise the value as given.
//
// #688 — scheduledTime is genuine UTC (ADODB parses Access's naive time as
// box-local, and foxbox reads it back with UTC getters — correct only because
// fvdts sits in the venue's timezone). Whatever Access/FVD shows IS the truth,
// so we render in the venue zone (America/Los_Angeles), matching
// scoreadmin-fe's classDisplay.js and the printed day sheet. NOT 'UTC' (that
// was this bug: it printed 4:44 PM where the day sheet shows 9:44 AM) and NOT
// browser-local (wrong for off-site viewers and in the report Lambda).
const VENUE_TIME_ZONE = "America/Los_Angeles";

export function formatTime(v) {
  if (!v) return "";
  if (/^\d{4}-\d{2}-\d{2}T/.test(String(v))) {
    const d = new Date(v);
    if (!Number.isNaN(d.getTime())) {
      return d.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        timeZone: VENUE_TIME_ZONE,
      });
    }
  }
  return String(v);
}

// #691 — the sticky header's live "time of day" clock. Always the VENUE's
// wall clock (America/Los_Angeles), same #688 decision as formatTime above:
// an announcer standing in the ring must see the time the ring is on, not
// wherever his own browser happens to sit. Distinct from formatClock.js's
// formatClockTime, which is deliberately BROWSER-local — that one is for
// client-side "this happened just now" strings like "last updated".
export function formatVenueClock(date) {
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
    timeZone: VENUE_TIME_ZONE,
  });
}

export default formatTime;
